<script lang="ts">
  import type { UserNotification } from "$types";
  import { Video, Heart, ChatCircle, Pencil, Balloon } from "phosphor-svelte";
  export let notification: UserNotification;
  export let hover: boolean = false;

  $: color = hover ? "var(--primary)" : "var(--title)";
</script>

<div class="icon" class:hover>
  <div class="holder">
    {#if notification.item[0]?.collection === "video"}
      <Video {color} />
      <div class="blam">VIDEO</div>
    {:else if notification.item[0]?.collection === "discussion_reaction"}
      <Heart {color} />
      <div class="blam">REACT</div>
    {:else if notification.item[0]?.collection === "discussion"}
      <ChatCircle {color} />
      <div class="blam">REPLY</div>
    {:else if notification.item[0]?.collection === "updates"}
      <Pencil {color} />
      <div class="blam">UPDATE</div>
    {:else}
      <Balloon {color} />
      <div class="blam">NEW</div>
    {/if}
  </div>
</div>

<style>
.icon {
  width: 2.5rem;
  height: 3rem;
  color: var(--offDark);
  display: grid;
  place-content: center;
}
.icon .holder {
  display: flex;
  flex-flow: column;
  gap: 0.25rem;
  align-items: center;
  justify-content: center;
}
.icon .holder .blam {
  font-size: 0.5rem;
  font-weight: normal;
  color: var(--offDark);
}
.icon.hover .holder .blam {
  color: var(--secondary);
}
</style>
